const NOT_LOGGED_IN_PAGES = [
  "index",
  "forget-password",
  "otp",
  "change-password",
  "verify",
  "finish",
];

export default NOT_LOGGED_IN_PAGES;
